import { SvgProps } from "components/icons/types";

export const ChartPieDollar = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7181_17184)">
      <path
        d="M10.5 9.33333C10.5 9.55383 10.6581 9.7405 10.8757 9.77667L12.6502 10.0724C13.4324 10.2025 14.0006 10.8733 14.0006 11.6667C14.0006 12.6315 13.2154 13.4167 12.2506 13.4167V14H11.0839V13.4167C10.1191 13.4167 9.33392 12.6315 9.33392 11.6667H10.5006C10.5006 11.9881 10.7625 12.25 11.0839 12.25H12.2506C12.572 12.25 12.8339 11.9881 12.8339 11.6667C12.8339 11.4462 12.6758 11.2595 12.4583 11.2233L10.6838 10.9276C9.9015 10.7975 9.33333 10.1267 9.33333 9.33333C9.33333 8.3685 10.1185 7.58333 11.0833 7.58333V7H12.25V7.58333C13.2148 7.58333 14 8.3685 14 9.33333H12.8333C12.8333 9.01192 12.5714 8.75 12.25 8.75H11.0833C10.7619 8.75 10.5 9.01192 10.5 9.33333ZM8.414 8.16667C8.61933 7.69942 8.94658 7.30158 9.35142 7H7V1.16667H6.41667C2.87875 1.16667 0 4.04542 0 7.58333C0 11.1212 2.87875 14 6.41667 14C7.27767 14 8.09783 13.8267 8.84858 13.5182C8.59892 13.2172 8.4105 12.8683 8.29733 12.4833C7.71283 12.7085 7.07933 12.8333 6.41667 12.8333C3.52217 12.8333 1.16667 10.4778 1.16667 7.58333C1.16667 4.88542 3.21183 2.6565 5.83333 2.36542V8.16667H8.414ZM14 5.25V5.83333H8.16667V0H8.75C11.6445 0 14 2.3555 14 5.25ZM12.7919 4.66667C12.5352 2.88108 11.1189 1.46475 9.33333 1.20808V4.66667H12.7919Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7181_17184">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
